import { useNavigate } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import BlockIcon from "@mui/icons-material/Block";
import {
  fonts,
  headingFonts,
  mainButtonStyles,
  notFoundBox,
} from "../../Styles/Styles.js";

export default function AdNotFound() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        height: "100vh", // Full viewport height
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 5,
      }}
    >
      <Box sx={{ ...notFoundBox }}>
        <BlockIcon
          sx={{
            color: "var(--primary-color)",
            fontSize: 50,
            opacity: 0.5,
            marginBottom: 1,
          }}
        />
        <Typography
          variant="h6"
          sx={{
            color: "var(--primary-color)",
            ...headingFonts,
          }}
        >
          Ad Not Found
        </Typography>
        <Typography variant="body2" sx={{ opacity: 0.7, ...fonts }}>
          The ad you're looking for might have been removed or never existed.
        </Typography>
        <Button
          onClick={() => navigate("/ads")}
          className="main-button-style"
          sx={{
            mt: 2,
            ...mainButtonStyles,
          }}
        >
          <>
            <span>GO BACK TO ALL ADS</span>
            <ArrowForwardOutlinedIcon />
          </>
        </Button>
      </Box>
    </Box>
  );
}
